/* Whether the device actually has a pointer to track.

   The custom cursor and the services spotlight are trailing pointer
   affordances: on a touch screen there is no hover to follow and the pointer
   the OS reports jumps on tap, so both listeners should never be attached. The
   query lives here rather than in each component because the two components
   that ask it were spelling it two different ways.

   This is a capability check, not a motion preference. The site does not read
   `prefers-reduced-motion` at all: motion is part of the design and is always
   shown, so there is no reduced-motion branch to ask for here. */
export function hasFinePointer() {
  return !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
}
